
import car from './car';

export default {
    car,
}